import { Button } from "components/ui/Button";
import type { FC } from "react";

export interface ProposalConfirmModalProps {
  isOpen: boolean;
  subject: string;
  body: string;
  toEmail: string;
  toName: string;
  fromName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 提案メール送信確認モーダル
 * @param {ProposalConfirmModalProps} props
 * @return {JSX.Element}
 */
export const ProposalConfirmModal: FC<ProposalConfirmModalProps> = ({
  isOpen,
  subject,
  body,
  toEmail,
  toName,
  fromName,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-lg">
        <h3 className="font-bold text-lg mb-4">メール送信の確認</h3>

        <div className="space-y-3">
          {/* 送信者 */}
          <div>
            <span className="text-xs text-gray-500">送信者</span>
            <p className="text-sm">{fromName}</p>
          </div>

          {/* 宛先 */}
          <div>
            <span className="text-xs text-gray-500">宛先</span>
            <p className="text-sm">
              {toName ? `${toName} <${toEmail}>` : toEmail}
            </p>
          </div>

          {/* 件名 */}
          <div>
            <span className="text-xs text-gray-500">件名</span>
            <p className="text-sm font-semibold">{subject}</p>
          </div>

          {/* 本文プレビュー */}
          <div>
            <span className="text-xs text-gray-500">本文</span>
            <div className="bg-gray-50 rounded-lg p-3 mt-1 max-h-60 overflow-y-auto">
              <p className="text-sm whitespace-pre-wrap">{body}</p>
            </div>
          </div>
        </div>

        <div className="modal-action">
          <Button variant="ghost" onClick={onCancel} type="button">
            キャンセル
          </Button>
          <Button onClick={onConfirm} type="button">
            送信する
          </Button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onCancel} />
    </div>
  );
};
